import type { MapObjectInstance } from '../../content/schema/map';

export interface AlignmentGuidesProps {
  selectedObject: MapObjectInstance;
  objectInstances: MapObjectInstance[];
  projectToScreen: (worldPos: [number, number, number]) => [number, number] | null;
}

export function AlignmentGuides({
  selectedObject,
  objectInstances,
  projectToScreen,
}: AlignmentGuidesProps) {
  const selScreen = projectToScreen(selectedObject.transform.position);
  if (!selScreen) return null;

  const [selX, selY] = selScreen;
  const guides: Array<{ type: 'v' | 'h'; val: number; key: string }> = [];

  for (const inst of objectInstances) {
    if (inst.id === selectedObject.id || inst.floor !== selectedObject.floor) continue;
    const otherScreen = projectToScreen(inst.transform.position);
    if (!otherScreen) continue;

    const [otherX, otherY] = otherScreen;
    if (Math.abs(selX - otherX) <= 4) {
      guides.push({ type: 'v', val: otherX, key: `v-${inst.id}` });
    }
    if (Math.abs(selY - otherY) <= 4) {
      guides.push({ type: 'h', val: otherY, key: `h-${inst.id}` });
    }
  }

  if (guides.length === 0) return null;

  return (
    <svg
      style={{
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: 9998,
      }}
    >
      {guides.map((guide) => (
        <line
          key={guide.key}
          x1={guide.type === 'v' ? guide.val : 0}
          y1={guide.type === 'h' ? guide.val : 0}
          x2={guide.type === 'v' ? guide.val : '100%'}
          y2={guide.type === 'h' ? guide.val : '100%'}
          stroke="#ffcf6b"
          strokeWidth="1.5"
          strokeDasharray="4 4"
        />
      ))}
    </svg>
  );
}
